import { Box, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import HeaderMobile from './HeaderMobile';
import BoletiaIcon from '@/components/BoletiaIcon';
import EventSummary from './EventNav/EventSummary';
import FanPass from './FanPass';

export default function FanPassMobile({ onChange, fanPass }) {
  const theme = useTheme();
  return (
    <>
      <HeaderMobile>
        <Container
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <BoletiaIcon
            sx={{
              width: '94px',
            }}
            onClick={() => {
              window.open(`https://boletia.com`, '_self');
            }}
            fill={
              theme.palette.mode === 'light'
                ? theme.palette.orange[0]
                : theme.palette.common.white
            }
          />
        </Container>
      </HeaderMobile>
      <Box
        sx={{
          pt: 10,
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Container>
          <EventSummary />
          <Box
            sx={{
              mt: 4,
            }}
          >
            <FanPass onChange={onChange} fanPass={fanPass}/>
          </Box>
        </Container>
      </Box>
    </>
  );
}
